import ApiUrl from "./apiUrl";
const axios = require('axios');
const url = new ApiUrl();

export const getCampaignEvents = async () => {
  const res = await axios({
    method: 'GET',
    headers: { Authorization: localStorage.getItem('token') },
    url: url.getEvents,
  });
  return res.data;
} 
